// Exemple molt bàsic. Això es pot expandir segons les necessitats.

export const isAuthenticated = () => {
    // Comprova si hi ha un token d'autenticació al localStorage
    const token = localStorage.getItem("authToken");
    return token !== null; // Retorna true si hi ha un token
  };
  
  export const setAuthToken = (token) => {
    // Desa el token d'autenticació al localStorage
    localStorage.setItem("authToken", token);
  };
  
  export const removeAuthToken = () => {
    // Elimina el token d'autenticació del localStorage
    localStorage.removeItem("authToken");
  };

  // Capçaleres amb el token per a crides a endpoints que validen JWT
  // al backend (patró GestioLaboralAuth.php i equivalents).
  export const authHeaders = (extra = {}) => {
    const token = localStorage.getItem("authToken");
    return {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...extra,
    };
  };

  // Error específic per distingir "sessió caducada" (ja gestionada: alerta +
  // redirecció al login) de qualsevol altre error, per evitar mostrar un
  // segon avís genèric al bloc catch de qui crida fetchAutenticat.
  export class SessioCaducadaError extends Error {}

  // Fetch per a endpoints que validen el JWT a cada crida. Si el backend
  // respon 401 (token absent/invàlid/caducat), neteja la sessió, avisa
  // l'usuari i el porta al login. Als altres casos, retorna la Response
  // normal perquè qui crida en faci `.json()` com sempre.
  export const fetchAutenticat = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      headers: authHeaders(options.headers || {}),
    });

    if (response.status === 401) {
      removeAuthToken();
      localStorage.removeItem("empresaSeleccionada");
      alert("La sessió ha caducat. Torna a iniciar sessió.");
      window.location.href = "/login";
      throw new SessioCaducadaError("Sessió caducada");
    }

    return response;
  };
  